import {Badge, Col, Row} from "react-bootstrap";
import {Link, useParams} from "react-router";
import {ProductsApi} from "../../api/ProductsApi";
import {useAsync} from "../../components/useAsync";
import {ErrorAlert} from "../../components/ErrorAlert";
import {LoadingSpinner} from "../../components/LoadingSpinner";
import {PageHeader} from "../../components/PageHeader";
import {ProductForm} from "./product/ProductForm";
import {ProductImages} from "./product/ProductImages";
import {ProductDemos} from "./product/ProductDemos";
import {ProductPressCard} from "./product/ProductPressCard";
import {ProductVersions} from "./product/ProductVersions";
import {ProductRequirementsCard} from "./product/ProductRequirementsCard";

export function ProductDetailPage() {
    const {productId = ''} = useParams();
    const {data: product, error, loading, reload, setData: setProduct} = useAsync(() => ProductsApi.get(productId), [productId]);

    return (
        <>
            <div className="mb-2"><Link to="/admin/products" className="small"><i className="bi bi-arrow-left me-1"></i>All products</Link></div>
            <ErrorAlert error={error} messages={{ 404: 'There is no such product.' }}/>
            {loading && !product && <LoadingSpinner/>}
            {product && (
                <>
                    <PageHeader title={product.name}>
                        <Link to={`/admin/products/${encodeURIComponent(product.id)}/documentation`} className="btn btn-outline-secondary">
                            <i className="bi bi-journal-text me-1" aria-hidden="true"></i>Edit documentation
                        </Link>
                        {product.published
                            ? <Link to={`/products/${encodeURIComponent(product.sku)}`} className="btn btn-outline-secondary">View on site</Link>
                            : <Badge bg="secondary" className="fs-6">Unpublished</Badge>}
                    </PageHeader>
                    <Row className="g-4">
                        <Col lg={5}>
                            <ProductForm product={product} onSaved={setProduct}/>
                            <ProductRequirementsCard product={product} onSaved={setProduct}/>
                        </Col>
                        <Col lg={7}>
                            <ProductVersions product={product} onChanged={reload}/>
                            <ProductImages product={product} onChanged={reload}/>
                            <ProductPressCard product={product} onChanged={reload}/>
                            <ProductDemos product={product} onChanged={reload}/>
                        </Col>
                    </Row>
                </>
            )}
        </>
    );
}
